import { render, staticRenderFns } from "./bankretconfigadd.vue?vue&type=template&id=d2b9f402&"
import script from "./bankretconfigadd.vue?vue&type=script&lang=js&"
export * from "./bankretconfigadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports